/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ version: NonNullable<unknown> }} Canvas_Versions_Restored_FromInputs */



/**
* | output |
* | --- |
* | "Restored from version {version}" |
*
* @param {Canvas_Versions_Restored_FromInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const canvas_versions_restored_from = /** @type {((inputs: Canvas_Versions_Restored_FromInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Canvas_Versions_Restored_FromInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Wiederhergestellt aus Version ${i?.version}`)
	return /** @type {LocalizedString} */ (`Restored from version ${i?.version}`)
});